// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CtaBanner-banner-L1FeU {
  --red: #e8232b;
  --red-d: #c2151c;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: linear-gradient(135deg, #e8232b, #c2151c);
  background: linear-gradient(135deg, var(--red), var(--red-d));
  color: #fff;
  text-align: center;
  padding: 56px 0;
}

.CtaBanner-wrap-UXBni {
  max-width: 820px;
  margin: 0 auto;
  padding: 0 24px;
}

.CtaBanner-title-zmHCD {
  font-size: clamp(24px, 4vw, 36px);
  font-weight: 800;
  margin: 0 0 12px;
  color: #fff;
}

.CtaBanner-sub-Pov4i {
  font-size: 17px;
  opacity: 0.92;
  margin: 0 0 26px;
  line-height: 1.55;
}

.CtaBanner-ctas-EMxj7 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CtaBanner-btnPrimary-iFmhN,
.CtaBanner-btnSecondary-cUfBt {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 28px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.CtaBanner-btnPrimary-iFmhN {
  background: #fff;
  color: var(--red);
}

.CtaBanner-btnPrimary-iFmhN:hover {
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  -webkit-box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
          box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
}

.CtaBanner-btnSecondary-cUfBt {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.55);
}

.CtaBanner-btnSecondary-cUfBt:hover {
  background: rgba(255, 255, 255, 0.24);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

@media (max-width: 680px) {
  .CtaBanner-banner-L1FeU {
    padding: 44px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/CtaBanner.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,uFAAuF;EACvF,qDAA6D;EAA7D,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;;AAEA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uFAA+D;EAA/D,+EAA+D;EAA/D,+DAA+D;EAA/D,kHAA+D;AACjE;;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,mDAA2C;UAA3C,2CAA2C;AAC7C;;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,2CAA2C;AAC7C;;AACA;EACE,qCAAqC;EACrC,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".banner {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: linear-gradient(135deg, var(--red), var(--red-d));\n  color: #fff;\n  text-align: center;\n  padding: 56px 0;\n}\n\n.wrap {\n  max-width: 820px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.title {\n  font-size: clamp(24px, 4vw, 36px);\n  font-weight: 800;\n  margin: 0 0 12px;\n  color: #fff;\n}\n.sub {\n  font-size: 17px;\n  opacity: 0.92;\n  margin: 0 0 26px;\n  line-height: 1.55;\n}\n\n.ctas {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btnPrimary,\n.btnSecondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 28px;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 16px;\n  text-decoration: none;\n  transition: transform 0.16s, box-shadow 0.16s, background 0.16s;\n}\n.btnPrimary {\n  background: #fff;\n  color: var(--red);\n}\n.btnPrimary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);\n}\n.btnSecondary {\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.55);\n}\n.btnSecondary:hover {\n  background: rgba(255, 255, 255, 0.24);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 680px) {\n  .banner {\n    padding: 44px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `CtaBanner-banner-L1FeU`,
	"wrap": `CtaBanner-wrap-UXBni`,
	"title": `CtaBanner-title-zmHCD`,
	"sub": `CtaBanner-sub-Pov4i`,
	"ctas": `CtaBanner-ctas-EMxj7`,
	"btnPrimary": `CtaBanner-btnPrimary-iFmhN`,
	"btnSecondary": `CtaBanner-btnSecondary-cUfBt`
};
module.exports = ___CSS_LOADER_EXPORT___;
